<template>
    <v-container>
        <v-row justify="start">
            <v-col>
                <v-data-table :headers="headers"
                              :items="hostlist"
                              :sort-by="[{ key: 'name', order: 'asc' }]"
                              :items-per-page="10"
                              :items-per-page-options="[
                                    { value: 5, title: '5' },
                                    { value: 10, title: '10' },
                                    { value: 25, title: '25' },
                                    { value: 50, title: '50' },
                                    { value: 100, title: '100' },
                                ]"
                              loading-text="Loading... Please wait"
                              :multi-sort="false"
                              :hover="false">
                    <template v-slot:top>
                        <div class="d-flex align-center">
                            <span class="font-weight-medium">Hosts</span>
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" max-width="75%">
                                <template v-slot:activator="{ props }">
                                    <v-btn variant="outlined" v-bind="props">New Host</v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="font-weight-bold">{{ hostFormTitle }}</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container>
                                            <input type="hidden" v-model="editItem.id" />
                                            <v-row>
                                                <v-col cols="12" md="2">
                                                    <v-switch class="w-auto"
                                                              variant="outlined"
                                                              v-model="editItem.isActive"
                                                              inset color="primary"
                                                              label="Is Active   ">
                                                    </v-switch>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <v-text-field class="w-auto" variant="outlined" v-model="editItem.name" label="Host Name"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="8">
                                                    <v-autocomplete v-model="editItem.protocolId"
                                                                    :items="protocolslist"
                                                                    item-title="name"
                                                                    item-value="id"
                                                                    label="Protocol"
                                                                    class="w-auto"
                                                                    variant="outlined"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                    <v-text-field readonly class="w-auto" variant="outlined" style="color: red" v-if="!this.editItem.protocolId">
                                                        "Protocol Type: Protocol Not Selected"
                                                    </v-text-field>
                                                    <v-text-field readonly class="w-auto" variant="outlined" v-else>
                                                        Protocol Type: {{ formatProtocolType(selectedProtocolType) }}
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field class="w-auto" variant="outlined" v-model="editItem.port" label="Port"></v-text-field>
                                                </v-col>
                                                <v-col>
                                                    <v-text-field class="w-auto"
                                                                  variant="outlined"
                                                                  v-model="editItem.deley"
                                                                  label="Deley"></v-text-field>
                                                </v-col>
                                                <v-col>
                                                    <v-text-field class="w-auto"
                                                                  variant="outlined"
                                                                  v-model="editItem.nii"
                                                                  label="NII"
                                                                  :rules="[v => /^\d{1,4}$/.test(v) || 'Unesite broj (max 4 znamenke)']"
                                                                  maxlength="4"
                                                                  type="text"
                                                                  @input="editItem.nii = editItem.nii.replace(/\D/g, '').slice(0, 4)">
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col>
                                                    <v-switch inset color="primary" v-model="editItem.useTpdu" label="UseTpdu" />
                                                    <v-switch inset color="primary" v-model="editItem.useStx" label="UseStx" />
                                                </v-col>
                                                <v-col>
                                                    <v-switch inset color="primary" v-model="editItem.sendENQ" label="Send ENQ" />
                                                    <v-switch inset color="primary" v-model="editItem.useVisa1" label="UseVisa1" />
                                                </v-col>
                                                <v-col>
                                                    <v-switch inset color="primary" v-model="editItem.useLen" label="UseLen" />
                                                    <v-text-field class="w-auto"
                                                                  variant="outlined"
                                                                  v-model="editItem.reqCount"
                                                                  label="Count"
                                                                  :rules="[v => /^\d{1,8}$/.test(v) || 'Unesite broj (max 8 znamenke)']"
                                                                  maxlength="8"
                                                                  type="text"
                                                                  @input="editItem.reqCount = editItem.reqCount.replace(/\D/g, '').slice(0, 8)">
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-switch inset color="primary" v-model="editItem.useTls" label="Use Tls" />
                                                <v-spacer></v-spacer>
                                                <v-text-field class="w-auto"
                                                              variant="outlined"
                                                              v-model="editItem.pfxPass"
                                                              label="Password"
                                                              type="text">
                                                </v-text-field>
                                                <input type="file"
                                                       ref="fileInput"
                                                       @change="uploadPfx"
                                                       style="display: none" />
                                                <v-btn color="primary"
                                                       variant="flat"
                                                       @click="$refs.fileInput.click()">Upload file</v-btn>
                                                <v-btn color="primary" @click="downloadPfx">Download file</v-btn>

                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                    <v-divider class="mt-5"></v-divider>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn variant="text" @click="close">Cancel</v-btn>
                                        <v-btn color="primary"
                                               variant="text"
                                               @click="funSaveItem"
                                               :loading="loading">Save</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </div>
                    </template>
                    <template v-slot:[`item.protocolType`]="{ item }">
                        <td>{{ formatProtocolType(item.protocolType) }}</td>
                    </template>
                    <template v-slot:[`item.isActive`]="{ item }">
                        <v-icon v-if="item.isActive"
                                icon="mdi-check-circle"
                                :color="getColor(item.isActive)"
                                center />
                        <v-icon :color="getColor(item.isActive)"
                                v-else icon="mdi-close-circle" center />
                    </template>
                    <template v-slot:[`item.isRunning`]="{ item }">
                        <v-icon v-if="item.isRunning"
                                icon="mdi-check-circle"
                                :color="getColor(item.isRunning)"
                                center />
                        <v-icon :color="getColor(item.isRunning)"
                                v-else icon="mdi-close-circle" center />
                    </template>
                    <template v-slot:[`item.sendENQ`]="{ item }">
                        <v-icon v-if="item.sendENQ"
                                icon="mdi-check-circle"
                                :color="getColor(item.sendENQ)"
                                center />
                        <v-icon :color="getColor(item.sendENQ)"
                                v-else icon="mdi-close-circle" center />
                    </template>

                    <template v-slot:[`item.useTpdu`]="{ item }">
                        <v-icon v-if="item.useTpdu"
                                icon="mdi-check-circle"
                                :color="getColor(item.useTpdu)"
                                center />
                        <v-icon :color="getColor(item.useTpdu)"
                                v-else icon="mdi-close-circle" center />
                    </template>

                    <template v-slot:[`item.useTls`]="{ item }">
                        <v-icon v-if="item.useTls"
                                icon="mdi-check-circle"
                                :color="getColor(item.useTls)"
                                center />
                        <v-icon :color="getColor(item.useTls)"
                                v-else icon="mdi-close-circle" center />
                    </template>

                    <template v-slot:[`item.useLen`]="{ item }">
                        <v-icon v-if="item.useLen"
                                icon="mdi-check-circle"
                                :color="getColor(item.useLen)"
                                center />
                        <v-icon :color="getColor(item.useLen)"
                                v-else icon="mdi-close-circle" center />
                    </template>

                    <template v-slot:[`item.useStx`]="{ item }">
                        <v-icon v-if="item.useStx"
                                icon="mdi-check-circle"
                                :color="getColor(item.useStx)"
                                center />
                        <v-icon :color="getColor(item.useStx)"
                                v-else icon="mdi-close-circle" center />
                    </template>

                    <template v-slot:[`item.useVisa1`]="{ item }">
                        <v-icon v-if="item.useVisa1"
                                icon="mdi-check-circle"
                                :color="getColor(item.useVisa1)"
                                center />
                        <v-icon :color="getColor(item.useVisa1)"
                                v-else icon="mdi-close-circle" center />
                    </template>

                    <template v-slot:[`item.action`]="{ item }">
                        <v-icon small @click="funEditItem(item)">mdi-pencil</v-icon>
                        <v-icon small @click="funDeleteItem(item)">mdi-delete</v-icon>
                    </template>

                    <template v-slot:no-data>
                        <span>No Data Available</span>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { mapState, mapActions } from "vuex";
    import {
        CREATE_HOST,
        EDIT_HOST,
        REMOVE_HOST,
        REMOVE_HOSTS,
    } from "@/store/_actiontypes";

    export default {
        data: () => ({
            loading: false,
            dialog: false,
            menu: false,
            selectedItems: [],
            headers: [
                { title: "Active", key: "isActive", width: 10 },
                { title: "Name", key: "name", width: 30 },
                { title: "Protocol Type", key: "protocolType", width: 30, align: 'start' },
                { title: "Protocol", key: "protocolName", width: 100, align: 'start' },
                { title: "Port", key: "port", width: 50 },
                { title: "Deley", key: "deley", width: 50 },
                //{ title: "ReqCount", key: "reqCount", width: 10 },
                //{ title: "Running", key: "isRunning", width: 10 },
                //{ title: "Status", key: "hostStatus", width: 150 },
                { title: "Tls", key: "useTls", width: 10 },
                { title: "NII", key: "nii", width: 10 },
                { title: "Use Stx", key: "useStx", width: 10 },
                { title: "Tpdu", key: "useTpdu", width: 10 },
                { title: "Len", key: "useLen", width: 10 },
                { title: "Use Visa1", key: "useVisa1", width: 10 },
                { title: "Actions", key: "action", sortable: false, width: 50 },
            ],
            editItem: {
                id: 0,
                name: "",
                protocolId: null,
                protocolName: "",
                protocolType: "",
                protocolTypeName: "",
                port: 0,
                deley: 0,
                reqCount: 0,
                sendENQ: false,
                isActive: false,
                isRunning: false,
                hostStatus:"",
                useTls: false,
                pfxFile: "",
                pfxPass: "",
                useTpdu: false,
                nii: "0000",
                useLen: false,
                useStx: false,
                useVisa1: false,
            },
            defaultItem: {
                id: 0,
                name: "",
                protocolId: null,
                protocolName: "",
                protocolType: "",
                protocolTypeName: "",
                port: 0,
                deley: 0,
                reqCount: 0,
                sendENQ: false,
                isActive: false,
                isRunning: false,
                hostStatus: "",
                useTls: false,
                pfxFile: "",
                pfxPass: "",
                useTpdu: false,
                nii: "0000",
                useLen: false,
                useStx: false,
                useVisa1: false,
            },
        }),

        computed: {
            ...mapState("protocols", ["protocolslist"]),
            ...mapState({ hostlist: (state) => state.hosts.hostlist }),
            hostFormTitle() {
                return this.editItem.id === 0 ? "New Host" : "Edit Host";
            },
            shouldShowSelect() {
                return this.hostlist.length >= 1;
            },
            selectedProtocolType() {
                if (!this.editItem.protocolId) {
                    return "";
                }

                const selectedProtocol = this.protocolslist.find(
                    (protocol) => protocol.id === this.editItem.protocolId
                );
                return selectedProtocol ? selectedProtocol.type : "";
            },
            elementTextColor() {
                return this.$vuetify.theme.global.name === "dark" ? "white" : "black";
            },
            elementBackgroundColor() {
                return this.$vuetify.theme.global.name === "dark" ? "#3d1924" : "#cfe4f2";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            selectedItems(val) {
                this.selectedItems = val;
            },
            "editItem.protocolId": function (newProtocolId) {
                if (!newProtocolId) {
                    this.editItem.protocolType = "";
                    return;
                }

                const selectedProtocol = this.protocolslist.find(
                    (protocol) => protocol.id === newProtocolId
                );

                this.editItem.protocolType = selectedProtocol
                    ? selectedProtocol.type
                    : "";
            },
        },
        methods: {
            ...mapActions("hosts", [CREATE_HOST, EDIT_HOST, REMOVE_HOST, REMOVE_HOSTS]),

            funEditItem(item) {
                this.editItem = Object.assign({}, item);
                this.dialog = true;
                this.editItem.protocolTypeName = this.formatProtocolType(
                    item.protocolType
                );
            },

            funDeleteItem(item) {
                confirm("Are you sure you want to delete this item?") &&
                    this.REMOVE_HOST({ id: item.id });
            },

            toggleSwitch(property) {
                this.editItem[property] = this.editItem[property] === 0 ? 1 : 0;
            },

            close() {
                this.dialog = false;
                this.editItem = Object.assign({}, this.defaultItem);
            },

            funSaveItem() {
                this.loading = true;
                var host = this.editItem;
                if (host.id == 0) {
                    if (!Number.isInteger(host.protocolId)) {
                        host.protocolId = this.defaultItem.protocolId;
                    }
                    this.CREATE_HOST({
                        host,
                    })
                        .then(() => {
                            this.close();
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    this.EDIT_HOST({
                        host,
                    })
                        .then(() => {
                            this.close();
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            },
            getColor(isactiv) {
                if (isactiv == 0) return "red";
                else return "green";
            },
            formatProtocolType(protocolType) {
                var ret = protocolType;
                var list = this.getProtocolType();
                if (ret < list.length) {
                    return list[ret];
                }
                return ret;
            },
            getProtocolType() {
                return ["HPDH", "SPDH", "APACS", "ISOHEX", "ISO8583"];
            },
            uploadPfx(event) {
                this.editItem.pfxFile = "";
                const file = event.target.files[0];
                if (!file) return;
                const fileName = file.name.toLowerCase();
                // Validate extension
                if (!fileName.endsWith(".pfx")) {
                    alert("Invalid file type. Please select a .pfx file.");
                    event.target.value = "";
                    return;
                }

                const reader = new FileReader();
                reader.onload = (e) => {
                    // e.target.result is an ArrayBuffer
                    const arrayBuffer = e.target.result;

                    // Convert to base64 (safe to send through API)
                    const binary = new Uint8Array(arrayBuffer);
                    let binaryStr = "";
                    for (let i = 0; i < binary.length; i++) {
                        binaryStr += String.fromCharCode(binary[i]);
                    }

                    this.editItem.pfxFile = btoa(binaryStr); // base64-encoded PFX

                    event.target.value = ""; // allow re-upload
                };

                reader.readAsArrayBuffer(file); // 👍 recommended
            },
            downloadPfx() {
                const base64 = this.editItem.pfxFile;
                const fileName = this.editItem.name + ".pfx";

                if (!base64) {
                    alert("No file available to download.");
                    return;
                }

                // Decode base64 → binary
                const binary = atob(base64);
                const len = binary.length;
                const bytes = new Uint8Array(len);

                for (let i = 0; i < len; i++) {
                    bytes[i] = binary.charCodeAt(i);
                }

                // Create a Blob for the file
                const blob = new Blob([bytes], { type: "application/x-pkcs12" });

                // Trigger download
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                a.click();

                // Cleanup
                URL.revokeObjectURL(url);
            }
        },


    };
</script>

<style>
    .element {
        padding: 10px;
        border: none;
    }

    .start {
        display: flex;
        justify-content: flex-start;
    }

    .end {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .delete {
        cursor: pointer;
    }
</style>